import { mapGetters } from 'vuex/dist/vuex.common.js'
import tabContentsMixin from 'js/mixins/journey_tabs.js'
import productMixin from 'js/pages/municipality-data/balance/products/_product-data.js'
import genericSvgIcon from 'js/components/_moverick/generic-svg-icon'
import transactionItem from 'js/pages/municipality-data/balance/products/show/_tabs/transactions/index.js'
import cardProduct from 'js/components/journeys/cards/product'
import template from './index.pug'

export default Vue.extend({
  name: 'products-tab',
  template: template(),
  data(){
    return {
      parentItem: '',
      childItem: [],
    }
  },
  components: { genericSvgIcon, cardProduct, transactionItem },
  mixins: [tabContentsMixin],
  computed:{
    ...mapGetters('user', ['products'])
  }
})